<template>
  <div class="oil-manage">
    <!-- 页面标题和统计卡片 -->
    <div class="page-header">
      <h2>油耗统计</h2>
      <div class="header-summary">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="summary-card">
              <div class="card-title">总加油量</div>
              <div class="card-amount">{{totalCount}} <span class="unit">L</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="summary-card">
              <div class="card-title">平均油耗</div>
              <div class="card-amount">{{avgConsumption}} <span class="unit">L/h</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="summary-card">
              <div class="card-title">总工作时长</div>
              <div class="card-amount">{{totalWorkHours}} <span class="unit">h</span></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 操作栏 -->
    <div class="operation-bar">
      <div class="right-operations">
        <el-form :model="searchForm.formData" :inline="true" size="small">
          <el-form-item label="车辆编号">
            <el-input
              v-model.trim="searchForm.formData.code"
              placeholder="请输入车辆编号"
              prefix-icon="el-icon-search"
              clearable
            />
          </el-form-item>
          <el-form-item label="统计类型">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="searchForm.formData.dateRange"
              :type="value"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="date-picker"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
            <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格卡片 -->
    <el-card class="table-card" shadow="hover">
      <el-table
        :data="table.tableData"
        border
        stripe
        row-key="id"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
      >
        <el-table-column prop="dateTime" label="时间" min-width="30" align="center" />
        <el-table-column prop="name" label="车辆编号" min-width="20" align="center" />
        <el-table-column prop="type" label="车辆类型" min-width="30" align="center" />
        <el-table-column prop="count" label="总加油量" min-width="30" align="center">
          <template #default="scope">
            <span class="amount">{{ scope.row.count }} L</span>
          </template>
        </el-table-column>
        <el-table-column prop="avgConsumption" label="平均油耗" min-width="30" align="center">
          <template #default="scope">
            <span class="amount">{{ (scope.row.count / scope.row.workHours).toFixed(2) }} L/h</span>
          </template>
        </el-table-column>
        <el-table-column prop="workHours" label="工作时长" min-width="30" align="center">
          <template #default="scope">
            <span>{{ scope.row.workHours }} h</span>
          </template>
        </el-table-column>
        <el-table-column prop="count1" label="加注次数" min-width="30" align="center" />
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total,sizes,prev,pager,next,jumper"
          :page-size="table.pageConfig.size"
          :page-sizes="[5, 10, 15, 20]"
          :total="table.pageConfig.total"
          :current-page.sync="table.pageConfig.current"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    const now = new Date() // 获取当前日期时间
    const yesterday = new Date(now) // 复制当前日期时间
    yesterday.setDate(yesterday.getDate() - 1) // 计算昨天的日期
    // 格式化日期为指定格式
    function formatDateToYYYYMMDDHHMMSS (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    }
    return {
      searchForm: {
        deptList: [],
        formData: {
          dateRange: [formatDateToYYYYMMDDHHMMSS(new Date(yesterday.setHours(0, 0, 0))), formatDateToYYYYMMDDHHMMSS(new Date(now))]
        }
      },
      dialogVisible: false,
      dialogImageUrl: '',
      table: {
        tableData: [
          {
            "sid": "1", 
            "name": "120", 
            "type": "自卸车", 
            "count": "100", 
            "count1": "1", 
            "dateTime": "2023-11-12",
            "workHours": "8"
          }
        ],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      },
      options: [{
        value: 'daterange',
        label: '日汇总',
      }, {
        value: 'monthrange',
        label: '月汇总',
      }],
      value: 'daterange',
      totalCount: 100,
      avgConsumption: '5.2', // 新增平均油耗
      totalWorkHours: '168', // 新增总工作时长
      tableHeaderStyle: {
        background: '#f5f7fa',
        color: '#606266',
        textAlign: 'center',
        fontWeight: 'bold',
        borderColor: '#ebeef5',
        padding: '12px 0'
      },
      tableCellStyle: {
        textAlign: 'center'
      }
    }
  },
  methods: {
    loading () {

    },
    formatDateToYYYYMMDDHHMMSS (date1) {
      const date = new Date(date1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    search () {
      this.loading()
    },
    reset () {
      this.searchForm.formData = {}
      this.loading()
    },
    created () {
      this.loading()
    }
  },
}
</script>

<style lang="scss" scoped>
.oil-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 40px);

  .page-header {
    margin-bottom: 24px;

    h2 {
      margin: 0 0 16px;
      color: #1f2f3d;
      font-weight: 500;
    }

    .header-summary {
      margin-top: 20px;
    }

    .summary-card {
      background: #fff;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      }

      .card-title {
        color: #909399;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .card-amount {
        color: #303133;
        font-size: 24px;
        font-weight: bold;

        .unit {
          font-size: 14px;
          color: #909399;
          margin-left: 4px;
        }
      }
    }
  }

  .operation-bar {
    background: #fff;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);

    .date-picker {
      width: 360px;
    }
  }

  .table-card {
    margin-bottom: 20px;

    .amount {
      color: #409EFF;
      font-weight: bold;
    }
  }

  .pagination-container {
    padding: 15px 0;
    text-align: right;
  }

  :deep(.el-table) {
    margin-top: 10px;
  }
}
</style>
